﻿import LandingPage from "./Registration/LandingPage.svelte";
import PersonalDetails from "./Registration/PersonalDetails.svelte";
import VehicleDetails from "./Registration/VehicleDetails.svelte";
import DocumentUpload from "./Registration/DocumentUpload.svelte";
import Agreements from "./Registration/Agreements.svelte";

const confirmationPages = [
    {
        component: LandingPage,
        routeId: "/Registration",
        confirmationHeading: null,
    },
    {
        component: PersonalDetails,
        routeId: "/Registration/PersonalDetails",
        confirmationHeading: "Your details",
    },
    {
        component: VehicleDetails,
        routeId: "/Registration/VehicleDetails",
        confirmationHeading: "Vehicle details",
    },
    {
        component: DocumentUpload,
        routeId: "/Registration/DocumentUpload",
        confirmationHeading: "Supporting documentation",
    },
    //{
    //    component: Agreements,
    //    routeId: "/Registration/Agreements",
    //    confirmationHeading: "Funding Agreement and Cost Agreement",
    //},
];

export default confirmationPages;